export class SpeedDetectorService {

	public detectSpeed(): void {
		if (window.addEventListener) {
			window.addEventListener('load', () => this.initiateSpeedDetection(), false);
		}
	}

	private initiateSpeedDetection() {
		let lastSpeedMeasureTime = localStorage.getItem('speed-measure-time');
		if (lastSpeedMeasureTime) {
			const lastSpeedMeasureTimeNumber = Number(lastSpeedMeasureTime);
			const now = Date.now();
			if (now - lastSpeedMeasureTimeNumber < 24 * 60 * 60 * 1000) {
				return;
			}
		}
		window.setTimeout(() => this.measureConnectionSpeed(), 30000);
	}

	private measureConnectionSpeed() {
		const imageAddr = "images/polygonum_bistorta.jpg";
		const downloadSize = 7300000; //bytes

		let startTime: number, endTime: number;
		let download = new Image();

		download.onload = function () {
			endTime = (new Date()).getTime();

			const duration = (endTime - startTime) / 1000;
			const bitsLoaded = downloadSize * 8;
			const speedBps = (bitsLoaded / duration);
			const speedKbps = (speedBps / 1000);
			const speedMbps = (speedKbps / 1000);

			console.log([
				"Your connection speed is:",
				speedBps.toFixed(2) + " bps",
				speedKbps.toFixed(2) + " kbps",
				speedMbps.toFixed(2) + " Mbps"
			]);

			localStorage.setItem('speed-in-kbps', speedKbps.toFixed(2));
			localStorage.setItem('speed-measure-time', Date.now().toString());
		}

		download.onerror = function () {
			localStorage.setItem('speed-in-kbps', 'N/A');
			localStorage.setItem('speed-measure-time', Date.now().toString());
			return;
		}

		startTime = (new Date()).getTime();
		const cacheBuster = "?nnn=" + startTime;
		download.src = imageAddr + cacheBuster;
	}
}
